/**
 * Configuración dinámica de API
 * Lee variables de entorno para construir las URLs correctas
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8743';
const API_PATH = process.env.REACT_APP_API_PATH || '';
const ENV = process.env.REACT_APP_ENV || 'development';

const API_URL = `${API_BASE_URL}/app`;

const GENERATOR_BASE_URL = API_BASE_URL;

const config = {
  apiUrl: API_URL,
  
  baseUrl: API_BASE_URL,
  
  apiPath: '/app',
  
  environment: ENV,
  
  endpoint: (path) => `${API_URL}${path}`,
  
  generatorUrl: (path) => `${GENERATOR_BASE_URL}${path}`,
  
  isProduction: ENV === 'production',
  isDevelopment: ENV === 'development',
};

if (config.isDevelopment) {
  console.log('🔧 API Configuration:', {
    baseUrl: config.baseUrl,
    apiUrl: config.apiUrl,
    environment: config.environment,
  });
}

export default config;
